import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './guards/auth.guard';
import { userManagementGuard } from './guards/user-management.guard';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {UnprocessedVinsComponent} from './unprocessed-vins/unprocessed-vins.component';
import {UnprocessedSoldComponent} from './unprocessed-sold/unprocessed-sold.component';
import { FaqComponent } from './faq/faq.component';
import { SummaryAlertsComponent } from './summary-alerts/summary-alerts.component';
import { VinLookupComponent } from './vin-lookup/vin-lookup.component';
import { UserManagementComponent } from './user-management/user-management.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-passphrase', component: ForgotPasswordComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: 'summary-alerts', component: SummaryAlertsComponent },
      { path: 'activity-by-date', component: DashboardComponent },
      { path: 'inventory-unprocessed', component: UnprocessedVinsComponent },
      { path: 'sold-unprocessed', component: UnprocessedSoldComponent },
      { path: 'download-certificate', component: VinLookupComponent },
      { path: 'faq', component: FaqComponent },
      /* { path: 'users', component: UserManagementComponent, canActivate: [userManagementGuard] }, */
      /* { path: 'users', component: UserManagementComponent}, */
      { path: '**', redirectTo: 'summary-alerts' }
    ]
  },
  { path: '**', redirectTo: '' }
];
